<template>
  <f7-page id="ua-verify-1" name="ua-verify-1" @page:afterin="afterin">
    <f7-navbar class="view-mobile no-border">
      <f7-nav-left class="back-button">
        <f7-link icon-f7="chevron_left" @click="backButton" color="black"></f7-link>
      </f7-nav-left>
      <f7-nav-right></f7-nav-right>
    </f7-navbar>
    <f7-block>
      <div class="fs-24 fw-bold mb-xxl">{{ $t('ua-choose-id-type-title') }}</div>
      <f7-list>
        <f7-list-item v-for="doc in docList" name="doc-ekyc" :key="doc.id" @click="chooseVerificationType(doc)">
          <p>{{doc.name}}</p>
          <i class="f7-icons">chevron_right</i>
        </f7-list-item>
      </f7-list>
    </f7-block>
  </f7-page>
</template>

<style>
#ua-verify-1 .list ul {
  background-color: transparent;
}
#ua-verify-1 .list .item-content {
  margin: 12px 0;
  border-radius: 10px;
  border: 1px solid #EFEFEF;
  background-color: #FFFFFF;
  padding: 20px;
  font-size: 16px;
  font-weight: 600;
  color: #13161D;
  line-height: 20px;
}
#ua-verify-1 .list .item-inner {
  padding: 0;
  min-height: auto;
}
#ua-verify-1 .list .item-inner:after {
  content: none;
}
#ua-verify-1 .list .item-inner p {
  margin: 0;
}
</style>

<script>
  import { mapGetters, mapActions } from "vuex";

  export default {
    props: {
      isFromHome: Boolean
    },
    mounted (){
      // Required for everypage. Toggle desktop-view footer.
      this.toggleFooterVisibility(false)
      this.$f7.$('.page-content').on('scroll', (e) => {
        this.toggleFooterVisibility(e.target)
      })
      this.getEkycTypeList();
    },
    data() {
      return {
        docList: [],
        mainDocList: [],
        otherDocList: [],
      }
    },
    methods: {
      ...mapActions('auth', ['login']),
      ...mapActions('ekycService', ['getEkycTypeList']),

      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },
      async getEkycTypeList() {
        const self = this;
        this.showPreloader();
        this.$api.ekycService.getEkycTypeList().then(function(result) {
          for (let i in result) {
            if(i == 'Others') {
              self.docList.push({id: 0, name: i});
              self.mainDocList.push({id: result[i].key, name: result[i].value});
              for (let j in result[i]) {
                self.otherDocList.push({id: result[i][j].key, name: result[i][j].value});
              }
            } else {
              self.docList.push({id: result[i].key, name: result[i].value});
              self.mainDocList.push({id: result[i].key, name: result[i].value});
            }
          }

          self.docList.forEach(function(item,x){
            if(item.id === "103"){
              self.docList.splice(x, 1);
              self.docList.unshift(item);
            }
          });

          self.docList.forEach(function(item,x){
            if(item.id === "120"){
              self.docList.splice(x, 1);
              self.docList.unshift(item);
            }
          });

          self.docList.forEach(function(item,x){
            if(item.id === "133"){
              self.docList.splice(x, 1);
              self.docList.unshift(item);
            }
          });

          self.docList.forEach(function(item,x){
            if(item.id === "154"){
              self.docList.splice(x, 1);
              self.docList.unshift(item);
            }
          });

          self.docList.forEach(function(item,x){
            if(item.id === "104"){
              self.docList.splice(x, 1);
              self.docList.unshift(item);
            }
          });

          self.hidePreloader();
        });
      },
      async chooseVerificationType(doc) {
        if(doc.id == 0) {
          this.docList = this.otherDocList;
        } else if(doc) {
          // As per request in Workplace Group 4 May 2023 09:17, set EKYC flow from account page same with in Slider Home Page
          this.$f7router.navigate("/verify/take-photo", { props: { doc: doc, isFromHome: true }});
        }
      },
      backButton() {
        this.$f7router.back({ transition: 'f7-push' });
      }
    },
    computed: {
      ...mapGetters('auth', [
          'authenticating',
          'authenticationError',
          'authenticationErrorCode',
          'authenticationSuccess'
      ])
    }
  }
</script>